import { Navigate, Route, Routes, Outlet } from 'react-router-dom'
import { CrewList } from './components/CrewList'
import { AssignmentPage } from './components/AssignmentPage'
import CrewDashboard from './components/CrewDashboard'
import { CrewDetails } from './components/CrewDetailsPage'
import { useAuth } from '../auth'
import { SignPage } from './components/SignPage'
import RestHour from './CrewFormTabs/RestHour'
import CrewOvertime from './CrewFormTabs/CrewOvertime'
import CrewAllotment from './CrewFormTabs/CrewAllotment'
import CrewClaims from './CrewFormTabs/CrewClaims'
import CrewDeductions from './CrewFormTabs/CrewDeductions'
import Appraisal from './CrewFormTabs/Appraisal'
import CrewTraining from './CrewFormTabs/CrewTraining'
import CrewComplaints from './CrewFormTabs/CrewComplaints'

// const operationsBreadCrumbs: Array<PageLink> = [
//     {
//         title: 'Operations',
//         path: '/operations',
//         isSeparator: false,
//         isActive: false,
//     },
//     {
//         title: '',
//         path: '',
//         isSeparator: true,
//         isActive: false,
//     },
// ]

import { useCrewingRoleAccess } from './core/crewingRoleAccess'

const CrewingPage = () => {
  const { currentUser, hasPermission } = useAuth()
  const { isCrew } = useCrewingRoleAccess()

  // Crew landing: crew role defaults to details only when they may read crew records.
  // Dashboard is the default landing for admin/company roles, crew details for crew role.
  const defaultRoute =
    isCrew && hasPermission('READ_CREW') ? 'crewdetails' : 'dashboard'


    return (
        <Routes>
            <Route element={<Outlet />}>
                <Route
                    index
                    element={<Navigate to={defaultRoute} replace />}  // ✅ Default to crew
                />
                <Route
                    path='dashboard'
                    element={<CrewDashboard />}
                />
                <Route
                    path='overview'
                    element={<CrewList />}
                />
                <Route
                    path='assignment'
                    element={<AssignmentPage />}
                />
                <Route
                    path='crewdetails'
                    element={<CrewDetails />}
                />
                <Route
                    path='signing'
                    element={<SignPage />}
                />
                <Route
                    path='resthours'
                    element={<RestHour />}
                />
                <Route
                    path='crewovertime'
                    element={<CrewOvertime />}
                />
                <Route
                    path='crewallotment'
                    element={<CrewAllotment />}
                />
                <Route
                    path='crewclaims'
                    element={<CrewClaims />}
                />
                <Route
                    path='crewdeductions'
                    element={<CrewDeductions />}
                />
                <Route
                    path='appraisal'
                    element={<Appraisal />}
                />
                <Route
                    path='crewtraining'
                    element={<CrewTraining />}
                />
                <Route
                    path='crewcomplaints'
                    element={<CrewComplaints />}
                />
            </Route>
        </Routes>
    )
}

export default CrewingPage
